export default "__VITE_ASSET__DecUerVX__"